const init = () => {
  const loadMoreButton = document.querySelector('.js-load-more');
  const loadMoreSection = document.querySelector('.js-load-more-section');
  const articleItems = document.querySelectorAll('.js-article-item');

  if (!loadMoreButton || !articleItems.length) {
    return;
  }

  let currentlyShown = 6;
  const itemsPerLoad = 6;

  const showMoreItems = () => {
    const hiddenItems = [];
    Array.from(articleItems).map((item) => {
      if (item.classList.contains('hidden')) {
        hiddenItems.push(item);
      }
    });

    const itemsToShow = hiddenItems.slice(0, itemsPerLoad);

    itemsToShow.forEach((item) => {
      item.classList.remove('hidden');
    });

    currentlyShown += itemsToShow.length;

    if (currentlyShown >= articleItems.length) {
      if (loadMoreSection) {
        loadMoreSection.classList.add('hidden');
      }
    }
  };

  loadMoreButton.addEventListener('click', showMoreItems);
};

export default {
  init,
};
